<template>
  <div>
    <!-- 展示一些加载提示等 -->
    Handling authentication...
  </div>
</template>

<script>
export default {
  name: "AuthCallback",
  mounted() {
    console.log(this.$route.query); // 这应该包含了code参数

    const code = this.$route.query.code;
    if (code) {
      console.log("GitHub authorization code:", code);
      // 假设验证成功，存储登录状态
      localStorage.setItem("isLoggedIn", true);
      // 重定向到Dashboard页面
      this.$router.push("/");
    } else {
      // 如果没有code参数，重定向到登录页面
      this.$router.push("/");
    }
  },
};
</script>
